import { logNewRelicPageAction, setCustomAttribute } from '@makemydeal/dr-activities-common';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { ApplicationCodes } from '@makemydeal/dr-platform-types';
import { reducerConfig } from '../reducers/reducerConfig';
import { isAutoSelectProgramByDefaultEnabled, isDealerAutoSelectSettingBypassed } from '../selectors/dealerSelectors';
import { getCalculationEndpointsState, getDealerForcedUpq } from '../selectors/offerNodeSelectors';
import * as types from '../types/actionTypes';

const MARKER_NONE = 'none';

const readMarker = (state: any): string => {
    return getCalculationEndpointsState(state)?.autoSelectProgramSavedAt || MARKER_NONE;
};

const emitSessionAttributes = (state: any) => {
    setCustomAttribute('autoSelectProgramSaved.marker', readMarker(state));
    if (!isDealerAutoSelectSettingBypassed(state)) {
        setCustomAttribute('autoSelectProgramSaved.gateActive', String(getDealerForcedUpq(state)));
    }
};

export const autoSelectProgramTelemetryMiddleware = (store: any) => (next: any) => (action: AnyFSA) => {
    const sourceApplication = reducerConfig?.sourceApplication ?? action.meta?.sourceApplication;
    const isMv = sourceApplication === ApplicationCodes.MV;

    const markerBefore = isMv ? readMarker(store.getState()) : MARKER_NONE;

    const result = next(action);

    if (!isMv) return result;

    if (action.type === types.INIT_SUCCESS) {
        const isAdminToggleEnabled = action.payload?.featureToggles?.enableAutoSelectProgramAdminSetting === true;
        if (!isAdminToggleEnabled) return result;

        const state = store.getState();

        const calculationEndpointByOfferType = getCalculationEndpointsState(state)?.calculationEndpointByOfferType;
        if (!calculationEndpointByOfferType) return result;

        if (!isDealerAutoSelectSettingBypassed(state)) {
            setCustomAttribute('autoSelectProgramByDefault', String(isAutoSelectProgramByDefaultEnabled(state)));
        }
        Object.entries(calculationEndpointByOfferType).forEach(([offerType, endpoint]) => {
            setCustomAttribute(`autoSelectProgramByDefault.${offerType}`, endpoint);
        });
        emitSessionAttributes(state);
        return result;
    }

    if (action.type === types.OFFER_SUBMISSION_SUCCESS || action.type === types.INIT_PENCIL_SUCCESS) {
        const state = store.getState();
        const markerAfter = readMarker(state);
        if (markerBefore === MARKER_NONE && markerAfter !== MARKER_NONE) {
            logNewRelicPageAction('autoSelectProgramMarkerLatched', {
                latchedAt: markerAfter,
                triggerActionType: action.type
            });
            emitSessionAttributes(state);
        }
    }

    return result;
};
